// ============================================
// SECTION — About
// ============================================

import {
  RiUserStarLine,
  RiCalendarLine,
  RiCheckDoubleLine,
  RiExternalLinkLine,
} from "react-icons/ri";
import { Link } from "react-router-dom";
import { TEAM } from "../data/content";
import { useInView } from "../hooks/useInView";
import "./About.css";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

function TeamCard({ member, delay, visible }) {
  return (
    <div
      className={`about__card stagger-child ${visible ? "visible" : ""}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      {/* Photo */}
      <div className="about__photo">
        {member.photo ? (
          <img
            src={member.photo}
            alt={member.name}
            className="about__photo-img"
          />
        ) : (
          <>
            <RiUserStarLine className="about__photo-icon" />
            <div className="about__photo-glow" />
          </>
        )}
      </div>

      {/* Bio */}
      <div className="about__bio">
        <h3 className="about__name">{member.name}</h3>
        <span className="about__role">{member.title}</span>

        <p className="about__para">{member.para1}</p>
        <p className="about__para">{member.para2}</p>

        <ul className="about__creds">
          {member.credentials.map((c) => (
            <li key={c}>
              <RiCheckDoubleLine className="about__cred-icon" />
              {c}
            </li>
          ))}
        </ul>

        <div className="about__bio-link-wrap">
          <Link
            className="btn-outline about__bio-link"
            to={`/bio/${member.id}`}
          >
            <RiExternalLinkLine /> View Bio
          </Link>
        </div>
      </div>
    </div>
  );
}

export default function About() {
  const [ref, visible] = useInView(0.08);

  return (
    <section id="about" className="about section-pad">
      <div className="container">
        <div className={`fade-up ${visible ? "visible" : ""}`}>
          <span className="section-label">Who We Are</span>
          <h2 className="section-title">Meet the Founder</h2>
          <p className="section-sub">
            A practitioner turned researcher, united by a mission to strengthen
            families and reduce recidivism through evidence-informed action.
          </p>
        </div>

        <div ref={ref} className="about__team">
          {TEAM.map((member, i) => (
            <TeamCard
              key={member.id}
              member={member}
              delay={i * 0.18}
              visible={visible}
            />
          ))}
        </div>
      </div>

      <div className="about__cta-wrap">
        <div className="container">
          <div className="about__cta">
            <p className="about__cta-kicker">Next Step</p>
            <h3 className="about__cta-title">Ready to work with us?</h3>
            <p className="about__cta-sub">
              Schedule a call to discuss your goals and build the right support
              strategy for your team or community.
            </p>
            <button
              className="btn-primary about__cta-btn"
              href="https://cal.com/schea91/introcall"
                  onClick={() =>
                    window.open("https://cal.com/schea91/introcall", "_blank")
                  }
            >
              <RiCalendarLine /> Book a Call
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
